import { useState } from "react";
import CuButton from "../../all-patient/components/CuButton";
// import CustomToolTip from "../../common_component/component/CustomToolTip";
import { CONSULTATION_ICONS } from "../../cufront-assets/icons/Icons";
import "../css/OtherIcons.css";
// import { Popup } from "semantic-ui-react";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { toast } from "react-toastify";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { previousVisitsAtom } from "../constants/_constant";
import { filterByTagType } from "./CustomField";
import { MdManageSearch } from "react-icons/md";
import Popup from "../../common_component/component/Popup";

const OtherIcons = ({
  type,
  tagId,
  setData,
  data,
  setDescriptionData,
  descriptionData,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [groupName, setGroupName] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const [previousData] = useAtom(previousVisitsAtom);
  const { role_id } = useCurrentRole();
  // const [group, setGroup] = useState({
  //   makeGroup: false,
  //   createGroup: false,
  // });

  const { data: medicineGroupData } = useItemsFilter(
    ApiEndPoint.QP_CM_RX_GROUP,
    `?action=getRxGroup&frontend=True&clinic_id=${clinic?.id}&name=${searchInput}`,
    clinic?.id && type === "medicine" && searchInput?.length > 0 ? true : false
  );

  const { data: customFieldData } = useItemsFilter(
    ApiEndPoint.QP_CM_TAG_GROUPS,
    `?action=getTagGroups&frontend=True&clinic_id=${clinic?.id}&group_for=${tagId}&group_name=${searchInput}`,
    clinic?.id && type === "customTags" && tagId && searchInput?.length > 0
      ? true
      : false
  );

  const { data: advicesData } = useItemsFilter(
    ApiEndPoint.ADVICES,
    `?action=getAdvices&frontend=True&clinic_id=${clinic?.id}&name=${searchInput}`,
    searchInput?.length > 0 && clinic?.id && type === "advice&direction"
      ? true
      : false
  );
  // const [isOpen, setIsOpen] = useState({
  //   createGrp: false,
  //   viewGrps: false,
  //   default: false,
  // });

  // const updateIsOpen = (updatedValues) => {
  //   setIsOpen(prevState => ({
  //     ...prevState,
  //     ...updatedValues
  //   }));
  // };

  const handleSearchGroup = (e) => {
    setSearchInput(e.target.value.toUpperCase());
  };

  const handleSelectGroup = (group) => {
    if (type === "medicine") {
      // console.log("Enter and selecte group", group);
      const modifiedMedicineData = group?.medicine_data?.map((val, index) => {
        return {
          id: val?.id,
          medicineName: val?.medicineName,
          recentlyUsedCount: 0,
          genericName: {
            id: val?.genericName?.id,
            name: val?.genericName?.name,
          },
          medicineType: {
            id: val?.medicineType?.id,
            name: val?.medicineType?.name,
          },
          dosage: {
            id: val?.dosage?.id,
            label: val?.dosage?.label,
            name: val?.dosage?.name,
          },
          unit: {
            id: val?.unit?.id,
            label: val?.unit?.label,
            name: val?.unit?.name,
          },
          when: {
            id: val?.when?.id,
            label: val?.when?.label,
            name: val?.when?.name,
          },
          frequency: {
            id: val?.frequency?.id,
            label: val?.frequency?.label,
            name: val?.frequency?.name,
          },
          duration: val?.duration,
          notes: {
            id: val?.notes?.id,
            name: val?.notes?.name,
          },
          timing: {
            name: "",
          },
          category: {
            name: "",
          },
        };
      });

      // Set both data and description
      const descriptionData = group?.medicine_data?.map((val, index) => {
        return {
          genericName: {
            name: val?.genericName?.name || "",
          },
          medicineType: {
            name: val?.medicineType?.name || "",
            label: val?.medicineType?.label || "",
          },
          index: index.toString(),
        };
      });

      // Update states
      setData(modifiedMedicineData);
      setDescriptionData(descriptionData);
    } else {
      setData(group);
    }
    setSearchInput("");
  };

  const createTagGroupMutation = useCreateItem(ApiEndPoint.QP_CM_TAG_GROUPS);
  const createRXGroupMutation = useCreateItem(ApiEndPoint.QP_CM_RX_GROUP);

  const handleMakeGroup = (e) => {
    e.preventDefault();
    if (data?.length > 1) {
      let payload;
      if (type === "medicine") {
        payload = {
          clinic_id: clinic?.id,
          doctor_user: role_id,
          name: groupName,
          action: "postRxGroup",
          frontend: "True",
          status: "draft",
          medicine_data: data,
          medicine_table: {
            ok: "ok",
          },
        };
        createRXGroupMutation.mutate(payload, {
          onSuccess: () => {
            setGroupName("");
            toast.success("Group created successfully");
          },
          onError: () => {},
        });
      }
      if (type === "customTags") {
        payload = {
          action: "postTagGroups",
          group_name: groupName,
          clinic_id: clinic?.id,
          backend: "True",
          doctor_user: role_id,
          group_for: tagId,
          group_item: data,
        };
        createTagGroupMutation.mutate(payload, {
          onSuccess: () => {
            setGroupName("");
            toast.success("Group created successfully");
          },
          onError: () => {},
        });
      }
    } else {
      toast.error("You cannot create a group with one item");
    }
  };

  const handlePrevClick = () => {
    if (previousData?.length > 0) {
      if (type === "medicine") {
        if (previousData[0]?.medicine_data?.length > 0) {
          setData(previousData[0]?.medicine_data);
        } else {
          toast.error("There is no medicine in your previous visit");
        }
        return;
      }
      if (type === "customTags") {
        const filteredData =
          filterByTagType(previousData[0]?.qp_cm_consultation_tags, tagId) ||
          [];
        if (filteredData?.length > 0) {
          setData({ group_item: filteredData || [] });
        } else {
          toast.error("There is no data in your previous visit");
        }
        return;
      }
      if (type === "advice&direction") {
        if (previousData[0]?.qp_cm_advices) {
          setData(previousData[0]?.qp_cm_advices);
        } else {
          toast.error("Your previous visit does not have advice");
        }
        return;
      }
    } else {
      toast.error("You have no previous visits");
    }
  };

  return (
    <div className="cu-consultation-other-icons-container">
      <div className="cu-consultation-other-icon">
        <Popup
          content="Previous Consultation"
          trigger={
            <img
              src={CONSULTATION_ICONS.reverse}
              alt="reverse"
              className="cu-consultation-other-reverse"
              onClick={handlePrevClick}
            />
          }
          position="top-left"
        />
      </div>
      {type === "advice&direction" && (
        <div className="cu-consultation-other-icon">
          <Popup
            position="top-left"
            hoverable={false}
            content={
              <div className="mt-1 h-14 w-[200px] flex  items-center">
                <div className="w-full relative">
                  <div className="helvetica text-sm">Search Advice By Name</div>
                  <input
                    type="text"
                    className="border rounded p-1 w-full h-8 focus:outline-none focus:border-blue-500"
                    placeholder="Search Advice"
                    value={searchInput}
                    onChange={handleSearchGroup}
                  />
                  {searchInput?.length > 0 && advicesData?.length > 0 && (
                    <div className="absolute bg-gray-100 rounded w-full z-10 max-h-[250px] overflow-auto">
                      {advicesData?.map((advc) => {
                        return (
                          <div
                            key={advc?.id}
                            onClick={() => handleSelectGroup(advc)}
                            className="cursor-pointer hover:bg-gray-300 p-3"
                          >
                            {advc?.name}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            }
            trigger={
              <img
                src={CONSULTATION_ICONS.createGrp}
                alt="create_grp"
                className="cu-consultation-other-create-grp"
              />
            }
            onDocumentClick={false}
            onClose={() => setSearchInput("")}
          />
        </div>
      )}
      {type !== "advice&direction" && (
        <div className="cu-consultation-other-icon">
          <Popup
            position="top-left"
            trigger={
              <img
                src={CONSULTATION_ICONS.createGrp}
                alt="create_grp"
                className="cu-consultation-other-create-grp"
              />
            }
            content={
              <div className="mt-1 w-[200px] flex items-center">
                <div className="w-full relative">
                  <div>
                    <label className="helvetica text-sm">Search Group</label>
                  </div>
                  <input
                    type="text"
                    className="border rounded p-1 mt-1 w-full h-8 focus:outline-none focus:border-blue-500"
                    placeholder="Search Group..."
                    value={searchInput}
                    onChange={handleSearchGroup}
                  />
                  {searchInput?.length > 0 &&
                    (medicineGroupData?.length > 0 ||
                      customFieldData?.length > 0) && (
                      <div className="absolute bg-gray-100 rounded w-full z-10">
                        {type === "medicine" &&
                          medicineGroupData?.map((med) => {
                            return (
                              <div
                                key={med?.id}
                                onClick={() => handleSelectGroup(med)}
                                className="cursor-pointer hover:bg-gray-300 p-3"
                              >
                                {med?.name}
                              </div>
                            );
                          })}
                        {type === "customTags" &&
                          customFieldData?.map((cfield) => {
                            return (
                              <div
                                key={cfield?.id}
                                onClick={() => handleSelectGroup(cfield)}
                                className="cursor-pointer hover:bg-gray-300 p-3"
                              >
                                {cfield?.group_name}
                              </div>
                            );
                          })}
                      </div>
                    )}
                </div>
              </div>
            }
            hoverable={false}
            onDocumentClick={false}
            onClose={() => setSearchInput("")}
          />
        </div>
      )}
      {type !== "advice&direction" && (
        <div className="cu-consultation-other-icon">
          <Popup
            position="top-left"
            trigger={
              <img
                src={CONSULTATION_ICONS.viewGrps}
                alt="view_grp"
                className="cu-consultation-other-view-grp cursor-pointer"
              />
            }
            content={
              <form className="mt-1 w-[250px]" onSubmit={handleMakeGroup}>
                <div className="w-full h-7 px-1 border-b font-bold">
                  Make a Group
                </div>
                <div className="px-2 pt-2">
                  <input
                    type="text"
                    className="border w-full rounded p-1 h-9 focus:outline-none focus:border-blue-500"
                    placeholder="Group Name"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value.toUpperCase())}
                    required
                  />
                </div>
                <div className="mt-2 w-full flex justify-end items-center">
                  <CuButton
                    className="w-32 h-10 rounded-lg helvetica bg-[#EBF8EC]"
                    type="submit"
                    isLoading={
                      createRXGroupMutation.isLoading ||
                      createTagGroupMutation.isLoading
                    }
                  >
                    Save
                  </CuButton>
                </div>
              </form>
            }
            onClose={() => setGroupName("")}
            hoverable={false}
            onDocumentClick={false}
          />
        </div>
      )}
    </div>
  );
};

export default OtherIcons;
